export default __webpack_public_path__ + "static/media/jQuery.3316fd7f.png";